import React, { useEffect } from "react";

import { showAlert } from "utils/utils";

const BuySell = () => {
  useEffect(() => {
    showAlert("Coming Soon");
  }, []);

  return <div className="buy-container"></div>;
};

export default BuySell;
